import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import GoogleMapComponent from "../Contacts/GoogleMapComponent"; // Import Google Map
import "./Contact.css";

const Contact = () => {
  useEffect(() => {
    AOS.init({ duration: 800 });
  }, []);

  return (
    <div className="contact">
      <header className="contact-header">
        <h1 data-aos="zoom-in">Contact us</h1>
      </header>

      <div className="contact-container">
        <div className="contact-left" data-aos="fade-right">
          <h2>OPENING HOURS: <span className="highlight">24/7</span></h2>
          <p>Most car rental services operate during standard business hours, typically from 8:00 AM to 8:00 PM on weekdays.</p>
          <div className="contact-details">
            <p className="detail">📞 <strong>7798573786</strong></p>
            <p className="detail">
              📍 <strong>Address: Daw, Mohammed Shafiq, Qureshi road Nagpur, plot number 115, Prashant Nagar, Police Line Takli, Nagpur, Maharashtra 440013</strong>
            </p>
          </div>
          <button className="get-taxi-btn">Get Taxi Online</button>
        </div>

        {/* Google Map Section */}
        <div className="contact-right" data-aos="fade-left">
          <h2>Our Location</h2>
          <div className="map-container">
            {/* <GoogleMapComponent /> */}
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3720.2422447665845!2d79.06871237526084!3d21.182533680505564!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bd4c1a65f5f041b%3A0x3f429fee9b179419!2sShriram%20cabs!5e0!3m2!1sen!2sin!4v1764146144282!5m2!1sen!2sin"  style={{border:"0;"}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
